module.exports = __webpack_public_path__ + "assets/img/txt-professionals-02.3cc379ff.svg";